module.exports = {
  "$id": "forgetPasswordReset",
  "type": "object",
  "properties": {
    "password": {
      "title": "密码",
      "type": "string",
      "format": "newPassword"
    },
    "confirmPassword": {
      "title": "确认密码",
      "type": "string",
      "format": "newPassword",
      "const": {
        "$data": "1/password"
      }
    }
  },
  "required": [
    "password",
    "confirmPassword"
  ],
  "errorMessage": {
    "password": {
      "message": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "密码不能为空"
    },
    "confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "请再次输入密码"
    },
  }
}
